import { render, staticRenderFns } from "./PremiumServiceCategories.vue?vue&type=template&id=2708415e"
import script from "./PremiumServiceCategories.ts?vue&type=script&lang=ts&external"
export * from "./PremiumServiceCategories.ts?vue&type=script&lang=ts&external"
import style0 from "./PremiumServiceCategories.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports